import React, { createContext, useReducer, useEffect } from 'react'


export type User = {
    _id: string;
    user_id?: string;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    organization?: string;
    phoneNumber?: string;
    allowNotifications: boolean;
    attemptingToAddDevice: boolean;
    latest_ping_from_device_controller: Date;
    is_outlet: boolean;
    device_credentials: Record<string, any>;
    device_to_add: string;
    calibrate_device: boolean;
    device_to_calibrate: string;
    calibration_incoming_message: string;
    calibration_outgoing_message: string;
    message: string;
    token: string;
    termsAccepted: boolean;
    /** From API; true when email is in backend ADMIN_EMAILS allowlist. */
    isAdmin?: boolean;
};

type AuthState = {
    user: User | null;
};

type AuthAction =
    | { type: "LOGIN"; payload: User }
    | { type: "LOGOUT" }
    | { type: "UPDATE"; payload: User };
    

type AuthDispatch = (action: AuthAction) => void;

type AuthContextType = AuthState & {
    dispatch: AuthDispatch;
};
    
export const AuthContext = createContext<AuthContextType>({
    user: null,
    dispatch: () => {},
});


export const authReducer = (state: AuthState, action: AuthAction): AuthState =>{
    switch (action.type){
        case "LOGIN":
            return { user: action.payload }
        case "LOGOUT":
            return { user: null }
        case "UPDATE":
            return {user: action.payload}
        default:
            return state
    }
}

type AuthContextProviderProps = {
    children: React.ReactNode;
};


export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
    } as AuthState);

    useEffect(() => {
        const user = localStorage.getItem('user');
    if (typeof user === 'string') {
        const parsedUser = JSON.parse(user);
        dispatch({ type: "LOGIN", payload: parsedUser });
    }

    }, []);


    return (
        <AuthContext.Provider value={{ ...state, dispatch }}>
            { children }
        </AuthContext.Provider>
    )
}

